import { graphql } from 'gatsby';
import React from 'react';
import { css } from '@emotion/react';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import ServiceTypesIcons from '../../franchise/microsite/service-types/icons';
import ServiceTypesText from '../../franchise/microsite/service-types/text';
import { StyledButtonAsLink } from '../../primitives/styled-button';
import { colors } from '../../primitives/colors';
import paddingDefault from '../../utils/padding-default';
import Container from '../../primitives/grid/container';
import { breakpoints } from '../../primitives/tokens';

const styles = {
    franchisePageHeading: css({
        fontSize: '36px',
        lineHeight: 1.25,
        marginBottom: '24px',
        [breakpoints.tb]: {
            marginBottom: '32px',
        },
    }),
    background: css({
        backgroundColor: colors.shadesWhite,
    }),
    serviceTypesText: css({
        marginTop: '32px',
    }),
    servicesWrap: css({
        marginTop: '24px',
    }),
    buttonWrap: css({
        marginTop: '32px',
    }),
};

// visitSiteCtaHref prop is used for Hyperlocal pages

const ServicesWeProvide: React.FC<Queries.ServicesWeProvideDataFragment & { visitSiteCtaHref?: string }> = (data) => {
    const { title, visitSiteCtaHref } = data || {};
    const { franchise, permalink } = useMicrosite();

    if (!franchise || !permalink) return null;

    const { servicesProvidedReadable } = franchise;

    if (!servicesProvidedReadable || servicesProvidedReadable.length === 0) return null;

    return (
        <div css={[paddingDefault(), styles.background]}>
            <Container>
                <h2
                    css={styles.franchisePageHeading}
                >
                    {title}
                </h2>
                <div css={styles.servicesWrap}>
                    <ServiceTypesIcons
                        servicesProvidedReadable={servicesProvidedReadable}
                        permalink={permalink}
                    />
                    <ServiceTypesText
                        heading="Additional Services"
                        servicesProvidedReadable={servicesProvidedReadable}
                        css={styles.serviceTypesText}
                        permalink={permalink}
                    />
                </div>
                {visitSiteCtaHref && (
                    <div css={styles.buttonWrap}>
                        <StyledButtonAsLink to={visitSiteCtaHref}>
                            Visit Our Site
                        </StyledButtonAsLink>
                    </div>
                )}
            </Container>
        </div>
    );
};

export const query = graphql`
    fragment ServicesWeProvideData on CsServicesWeProvideGroup {
        title
    }
`;

export default ServicesWeProvide;
